module.exports = __webpack_public_path__ + "img/prize-03.f66ae769.png";